<template>
    <div class="lam-tab-section">
        <div v-if="!!fullWidth" class="uk-panel lam-full-width-section">
            <slot></slot>
        </div>
        <div v-else class="uk-grid uk-grid-small">
            <div class="uk-width-1-3">
                <h3 v-if="!!title">
                    {{ title }}
                    <slot name="title-actions"></slot>
                </h3>
                <div v-if="has_information" class="uk-width-9-10 uk-text-muted lam-tab-section-information">
                    <slot name="information"></slot>
                </div>
            </div>
            <div class="uk-width-2-3">
                <slot></slot>
            </div>
        </div>
        <hr v-if="bordered" class="uk-margin-top uk-margin-bottom">
    </div>
</template>

<script type="text/javascript">
export default {
    computed: {
        has_information () {
            return !!this.$slots.information
        }
    },
    props: {
        title: {
            type: String,
            required: true
        },
        fullWidth: {
            type: Boolean,
            default: false
        },
        bordered: {
            type: Boolean,
            default: true
        }
    }
}
</script>
